import * as moment from 'moment';

export function parseMessageTimestamp(value: any): moment.Moment {
  if (!value) {
    return moment.invalid();
  }

  const text = String(value).trim();
  const formats = [
    moment.ISO_8601,
    'YYYY-MM-DD HH:mm:ss',
    'YYYY-MM-DD HH:mm::ss',
    'YYYY-MM-DD HH:mm',
    'YYYY-DD-MM,HH:mm',
    'YYYY-DD-MM, HH:mm',
    'DD-MM-YYYY,HH:mm',
    'DD-MM-YYYY, HH:mm',
  ];

  return moment(text, formats, true);
}

export function displayMessageTimestamp(value: any): string {
  const parsed = parseMessageTimestamp(value);

  if (!parsed.isValid()) {
    return value || '';
  }

  return parsed.format('DD-MM-YYYY, HH:mm');
}

export function sortByNewestTimestamp<T>(items: T[], timestampFields: string[]): T[] {
  return items.slice().sort((left: T, right: T) => {
    const timestampDifference = getFirstValidTimestamp(right, timestampFields) - getFirstValidTimestamp(left, timestampFields);

    if (timestampDifference !== 0) {
      return timestampDifference;
    }

    return getSortableId(right) - getSortableId(left);
  });
}

function getFirstValidTimestamp(item: any, timestampFields: string[]): number {
  for (const field of timestampFields) {
    const parsed = parseMessageTimestamp(item && item[field]);

    if (parsed.isValid()) {
      return parsed.valueOf();
    }
  }

  return 0;
}

function getSortableId(item: any): number {
  const id = Number(item && item.id);

  return isNaN(id) ? 0 : id;
}
